import React, { useState, useEffect } from 'react';
import { CommonHeader } from '../../components/commons';
import { connect } from 'react-redux';
import {
    resetSession
} from '../../redux/auth'
import { RootState } from '../../redux/rootReducers';
import {
    AddDocumentLinkPayloadType,
    AddJobProgressCommentPayload,
    GetAllDocumentsLinkPayloadType,
    GetJobProgressCommentsPayload
} from '../../commonTypes/listing';
import { DocumentsLinkType, JobProgressCommentType, JobTrackerListingType } from '../../redux/listing/listingTypes';
import { Loader, ErrorSuccessModal } from '../../components/commons/';
import ProgressCommentsModal from '../../components/JobListing/ProgressCommentsModal';
import LinkUploadModal from '../../components/JobListing/LinkUploadModal';
import toast, { Toaster } from 'react-hot-toast';
import { JOB_TRACKER_HEADERS } from '../../constant/tableHeadersConstants/jobProgressHeaderConst';
import { JobProgressTable } from '../../components/AdminReports';
import { addJobCommentsAction, addJobLinkAction, getJobCommentsDetailsAction, getJobLinksDetailsAction, getJobsListAction, resetDocumentsLinkList, resetError, resetJobProgressCommentsListing, resetJobProgressCommentsSuccess, resetJobsList, resetJobsTotalCount, resetSuccess } from '../../redux/jobs';

type AppProps = {
    token: string | null;
    success: number | null;
    fetching: boolean;
    error: string | null | undefined;
    history: any;
    statusCode: number | null;
    jobProgressCommentsFetching: boolean;
    jobProgressCommentsList: [] | JobProgressCommentType[];
    jobProgressCommentsSuccess: number | null;
    totalJobsCount: number;
    jobTrackerListing: [] | JobTrackerListingType[];
    documentsLinkList: [] | DocumentsLinkType[];
    dispatchGetJobTrackerListing: (data: any) => void;
    dispatchResetListingError: () => void;
    dispatchResetJobsTotalCount: () => void;
    dispatchResetListingSuccess: () => void;
    dispatchResetJobTrackerListing: () => void;
    dispatchResetSession: () => void;
    dispatchResetJobProgressCommentsListing: () => void;
    dispatchResetJobProgressCommentsSuccess: () => void;
    dispatchGetAllJobProgressCommentsAction: (data: GetJobProgressCommentsPayload) => void;
    dispatchAddJobProgressCommentAction: (data: AddJobProgressCommentPayload) => void;
    dispatchAddDocumentLinkAction: (data: AddDocumentLinkPayloadType) => void;
    dispatchGetDocumentsLinkAction: (data: GetAllDocumentsLinkPayloadType) => void;
    dispatchResetDocumentsLinkList: () => void;
}

const JobTrackerListing = ({
    fetching,
    success,
    token,
    error,
    statusCode,
    jobTrackerListing,
    jobProgressCommentsFetching,
    jobProgressCommentsList,
    jobProgressCommentsSuccess,
    history,
    documentsLinkList,
    totalJobsCount,
    dispatchResetJobsTotalCount,
    dispatchGetJobTrackerListing,
    dispatchResetListingError,
    dispatchResetListingSuccess,
    dispatchResetSession,
    dispatchResetJobTrackerListing,
    dispatchAddJobProgressCommentAction,
    dispatchGetAllJobProgressCommentsAction,
    dispatchResetJobProgressCommentsSuccess,
    dispatchAddDocumentLinkAction,
    dispatchGetDocumentsLinkAction,
    dispatchResetDocumentsLinkList
}: AppProps) => {
    const client_code = history?.location?.state?.client_code ?
        history.location.state.client_code : 0;

    const company_name = history && history.location && history.location.state && history.location.state.company_name ? history.location.state.company_name : '';

    const [showProgressCommentsModal, setShowProgressCommentsModal] = useState<boolean>(false);
    const [showLinkUploadModal, setShowLinkUploadModal] = useState<boolean>(false);
    const [jobsData, setJobsData] = useState<JobTrackerListingType | null>(null);
    const [jobId, setJobId] = useState<number>(0);
    const [jobProgressComment, setJobProgressComments] = useState<JobProgressCommentType[] | []>([]);
    const [modalType, setModalType] = useState<string>('');
    const getPage = 'job-Tracker-List';
    const [commentState, setCommentState] = useState<boolean>(false);


    useEffect(() => {
        dispatchResetJobProgressCommentsSuccess()
        if (token && client_code) {
            let finalData = {
                clientCode: client_code,
                token,
                status: "1"
            }
            dispatchResetJobTrackerListing();
            dispatchGetJobTrackerListing(finalData);
        }
        dispatchResetListingSuccess();
        dispatchResetListingError();
        dispatchResetJobsTotalCount();
        setModalType('');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (jobProgressCommentsList) {
            setJobProgressComments(jobProgressCommentsList)
        }
    }, [jobProgressCommentsList])

    const handleToggleProgressCommentsModal = () => {
        setShowProgressCommentsModal(!showProgressCommentsModal);
        // 
        if(commentState){
        if (token && client_code) {
            let finalData = {
                clientCode: client_code,
                token,
                status: "1"
            }
            dispatchGetJobTrackerListing(finalData);
        }
    }

    };

    const handleToggleLinkUploadModal = () => {
        setShowLinkUploadModal(!showLinkUploadModal)
    }

    const handleSetJobsData = (data: any, type: string) => {
        setJobProgressComments([]);
        setJobsData(data);
        setJobId(data?._id);
        setModalType(type);

        if (type === 'comments') {
            let finalData: GetJobProgressCommentsPayload = {
                job_id: data?._id,
                token,
            }

            dispatchGetAllJobProgressCommentsAction(finalData);
        } else if (type === 'documents') {
            dispatchResetDocumentsLinkList();
            let finalData: GetAllDocumentsLinkPayloadType = {
                job_id: data?._id,
                token
            }

            dispatchGetDocumentsLinkAction(finalData);
        }
    };

    const handleSubmitJobComment = (data: any) => {
        setCommentState(true);
        let finalData: AddJobProgressCommentPayload = {
            job_id: data?.id,
            comment: data?.commentText,
            token
        };
        dispatchAddJobProgressCommentAction(finalData);
    };

    const handleSubmitDocumentLink = (data: AddDocumentLinkPayloadType) => {
        let finalData: AddDocumentLinkPayloadType = {
            link: data?.link,
            token,
            job_id: data?.job_id,
            description: data?.description
        };

        dispatchAddDocumentLinkAction(finalData);
    };

    const handleErrorModal = () => {
        if (success === 0|| jobProgressCommentsSuccess===0) {
            if (statusCode === 401) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message="Session Expired. Please Login Again!"
                        buttonText="Logout"
                        onPress={() => dispatchResetSession()}
                        statusCode={statusCode}
                    />
                )
            } else if ((!!error && statusCode !== 401)) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message={error}
                        buttonText="OK"
                        onPress={() => {
                            dispatchResetListingError();
                        }}
                    />
                )
            }
        }

        if (jobProgressCommentsSuccess === 1) {
            dispatchResetJobProgressCommentsSuccess();
            if (modalType === 'comments') {
                toast.success('Comment Added Successfully!', {
                    duration: 2000
                });

                let finalData: GetJobProgressCommentsPayload = {
                    job_id: jobId,
                    token,
                }

                dispatchGetAllJobProgressCommentsAction(finalData);
            } else if (modalType === 'documents') {
                toast.success('Document Link Added Successfully!', {
                    duration: 2000
                });

                let finalData: GetAllDocumentsLinkPayloadType = {
                    job_id: jobId,
                    token,
                }

                dispatchGetDocumentsLinkAction(finalData);
                dispatchResetJobProgressCommentsSuccess();
            }
        }

        return false;
    }

    return (
        <div className="job-tracker-listing--wrapper">
            <CommonHeader title="Job Tracker List" client_code={client_code} company_name={company_name} />
            <div className="col-md-12 mt-4">
                <div className="new-table-card">
                    <div className='header'>
                        <div className="left-header">
                            <div className="heading">Job Tracker List</div>
                            {!fetching && <div className="sub-heading" style={{ marginTop: "-22px" }}>{`Total ${totalJobsCount ? totalJobsCount : 0
                                } entries found`}</div>}
                        </div>
                    </div>
                    <JobProgressTable
                        data={jobTrackerListing}
                        headers={JOB_TRACKER_HEADERS}
                        fetching={fetching}
                        type={"noUnderline"}
                        handleSetJobsData={handleSetJobsData}
                        handleToggleProgressCommentsModal={handleToggleProgressCommentsModal}
                        isAdminReport={false}
                        handleToggleLinkUploadModal={handleToggleLinkUploadModal}
                    />
                </div>
            </div>
            {fetching && <Loader />}
            {handleErrorModal()}
            <Toaster />
            {
                showProgressCommentsModal && <ProgressCommentsModal
                    modal={showProgressCommentsModal}
                    toggleModal={handleToggleProgressCommentsModal}
                    characterLength={150}
                    data={jobsData}
                    handlePostComment={handleSubmitJobComment}
                    commentFetching={jobProgressCommentsFetching}
                    commentsSuccess={jobProgressCommentsSuccess}
                    jobProgressCommentsList={jobProgressCommentsList}
                    showInputBox
                />
            }
            {
                showLinkUploadModal && <LinkUploadModal
                    modal={showLinkUploadModal}
                    toggleModal={handleToggleLinkUploadModal}
                    data={jobsData}
                    showInputBox
                    client_code={client_code}
                    company_name={company_name}
                    handleAddDocumentLink={handleSubmitDocumentLink}
                    documentsLinkList={documentsLinkList}
                    commentFetching={jobProgressCommentsFetching}
                    title={getPage}
                />
            }
        </div>
    )
}

const mapTosStateProps = (state: RootState) => ({
    token: state.auth.token,
    fetching: state.jobs.fetching,
    error: state.jobs.error,
    jobTrackerListing: state.jobs.jobsList,
    success: state.jobs.success,
    statusCode: state.jobs.statusCode,
    jobProgressCommentsFetching: state.jobs.jobProgressCommentsFetching,
    jobProgressCommentsList: state.jobs.jobProgressCommentsList,
    jobProgressCommentsSuccess: state.jobs.jobProgressCommentsSuccess,
    documentsLinkList: state.jobs.documentsLinkList,
    totalJobsCount:state.jobs.totalJobsCount
});

const mapDispatchToProps = (dispatch: any) => ({
    dispatchGetJobTrackerListing: (data: any) =>
        dispatch(getJobsListAction(data)),
    dispatchResetListingError: () => dispatch(resetError()),
    dispatchResetJobsTotalCount: () => dispatch(resetJobsTotalCount()),
    dispatchResetListingSuccess: () => dispatch(resetSuccess()),
    dispatchResetJobTrackerListing: () => dispatch(resetJobsList()),
    dispatchResetSession: () => dispatch(resetSession()),
    dispatchResetJobProgressCommentsListing: () => dispatch(resetJobProgressCommentsListing()),
    dispatchResetJobProgressCommentsSuccess: () => dispatch(resetJobProgressCommentsSuccess()),
    dispatchGetAllJobProgressCommentsAction: (data: GetJobProgressCommentsPayload) =>
        dispatch(getJobCommentsDetailsAction(data)),
    dispatchAddJobProgressCommentAction: (data: AddJobProgressCommentPayload) =>
        dispatch(addJobCommentsAction(data)),
    dispatchAddDocumentLinkAction: (data: AddDocumentLinkPayloadType) =>
        dispatch(addJobLinkAction(data)),
    dispatchGetDocumentsLinkAction: (data: GetAllDocumentsLinkPayloadType) =>
        dispatch(getJobLinksDetailsAction(data)),
    dispatchResetDocumentsLinkList: () => dispatch(resetDocumentsLinkList())
});


export default connect(mapTosStateProps, mapDispatchToProps)(JobTrackerListing);